import { uploadFiletypeListSelector } from "pages/UploadCertificate/state/uploadCertificateFileState";
import { uploadFiletypeListSelector as gridFormingUploadFiletypeListSelector } from "pages/UploadGridFormingCertificate/state/uploadCertificateFileState";
import * as React from "react";
import { useRecoilValue } from "recoil";
import Props from "./index.d";

const CertificateFileUploadList: React.FC<Props> = (props) => {
  const { formVersion } = props;

  // Determine which selector to use based on formVersion
  const isGridForming = formVersion === "matrixCertificateCreate";
  const filetypeListSelector = isGridForming ? gridFormingUploadFiletypeListSelector : uploadFiletypeListSelector;

  const fileTypes = useRecoilValue(filetypeListSelector);
  const {
    data: { setAndSave, state },
  } = props;

  React.useEffect(() => {
    if (state !== fileTypes && (state || fileTypes.length)) {
      setAndSave(fileTypes);
    }
  }, [setAndSave, fileTypes, state]);

  return null;
};

export default CertificateFileUploadList;
